"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function updateStep(state, stepName, modifier) {
    var stepIndex = lodash_1.findIndex(state.steps, (function (step) { return step.name === stepName; }));
    var steps = lodash_1.cloneDeep(state.steps);
    steps[stepIndex] = modifier(steps[stepIndex]);
    state.steps = steps;
}
// set a step (specified by name) to completed 
function setStepCompleted(state, stepName) {
    updateStep(state, stepName, function (step) { step.completed = true; return step; });
}
exports.setStepCompleted = setStepCompleted;
// set a step (specified by name) and all its afterwards steps to incompleted
function setStepIncompleted(state, stepName) {
    updateStep(state, stepName, function (step) { step.completed = false; return step; });
    lodash_1.forEachRight(state.steps, function (storeStep) {
        if (storeStep.name === stepName) {
            return false;
        }
        updateStep(state, storeStep.name, function (step) { step.completed = false; return step; });
    });
}
exports.setStepIncompleted = setStepIncompleted;
function RESET_STATE(state) {
    if (state.steps) {
        setStepIncompleted(state, 'bookingPersons');
    }
}
exports.RESET_STATE = RESET_STATE;
// export everything compliant to the vuex specification for getters
exports.default = {
    setStepCompleted: setStepCompleted, setStepIncompleted: setStepIncompleted,
    RESET_STATE: RESET_STATE
};
//# sourceMappingURL=mutations.js.map